module.exports = __webpack_public_path__ + "static/media/banner-twitter-icon.516ded49.svg";